import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: false
})
export class PrivacyPolicyComponent {

  constructor(private location: Location) {}

  close(): void {
    window.close();

    setTimeout(() => {
      if (!window.closed) {
        this.location.back();
      }
    }, 100);
  }
}
